import { addClass } from '@H/class-list';

export const isMobile = () => {
    return (
        window.WURFL.is_mobile &&
        (window.WURFL.form_factor == 'Smartphone' ||
            window.WURFL.form_factor == 'Feature Phone' ||
            window.WURFL.form_factor == 'Other Mobile')
    );
};

export const isTablet = () => {
    return window.WURFL.is_mobile && window.WURFL.form_factor == 'Tablet';
};

export const isDesktop = () => {
    return !window.WURFL.is_mobile && window.WURFL.form_factor == 'Desktop';
};

export function tryTask(cb) {
    return async function() {
        try {
            await cb();
        } catch (error) {
            const timeout = setTimeout(async () => {
                await tryTask(cb);
                clearTimeout(timeout);
            }, 300);
        }
    }
}

/**
 * Grabs the WURFL window variable and applies
 * the body calss.
 */
export async function grabWURFL() {
    const script = document.createElement('script');
    const head = document.getElementsByTagName('head')[0];
    const scriptEl = head.querySelector('#wurflInclude');
    if (scriptEl) {
        head.removeChild(scriptEl);
    }
    script.type = 'text/javascript';
    script.id = 'wurflInclude';

    return new Promise((resolve, reject) => {
        script.onload = function() {
            setBodyClass()
            resolve();
        }

        script.onerror = function() {
            reject('error');
        }

        script.src = `https://wurfl.io/wurfl.js${window.ENV.APP_DEBUG ? '?debug=true' : ''}`;
        head.appendChild(script);
    });
}

export const setBodyClass = () => {
    if (isMobile()) {
        addClass(document.body, 'isMobile');
    } else if (isTablet()) {
        addClass(document.body, 'isTablet');
    } else if (isDesktop()) {
        addClass(document.body, 'isDesktop');
    }
};

const mobileMatch =
    'screen and (orientation: landscape), (max-width: 850px), (max-height: 440px)';

export const mobileLike = () => {
    // Mobile like media query.
    // screen AND landscape AND maxW850 OR maxH440
    const mql = window.matchMedia(mobileMatch);
    return mql;
};



// WEBPACK FOOTER //
// ./resources/assets/js/helpers/device_helpers.js